import { render, staticRenderFns } from "./leftLabelList.vue?vue&type=template&id=1a94b376&scoped=true&"
import script from "./leftLabelList.vue?vue&type=script&lang=js&"
export * from "./leftLabelList.vue?vue&type=script&lang=js&"
import style0 from "./leftLabelList.vue?vue&type=style&index=0&id=1a94b376&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a94b376",
  null
  
)

export default component.exports